import axios from 'axios'
import router from '@/router'
import store from '@/store'

// cookieを有効にする
axios.defaults.withCredentials = true
const prodHostName = 'withm.net'
const prodWebApiUrl = 'https://withm.net/members/'
const devWebApiUrl = 'https://develop.withm.net/members/'
let debug = false

// const baseUrl = 'https://bynumbers.jp/withm/'
let baseUrl = devWebApiUrl
if (location.hostname === prodHostName) {
  // production
  baseUrl = prodWebApiUrl
} else {
  debug = true
}

const onSuccess = (resp) => {
  if (debug) {
    console.log(resp)
  }
  return Promise.resolve(resp)
}
const onError = (e) => {
  if (debug) {
    console.log(e)
  }
  if (e.response.status === 401) {
    if (router.app.$route.name !== 'Login') {
      router.app.$router.push('/login')
      store.dispatch('showAuthAlert')
    }
  }
  // throw new Error('API error.' + JSON.stringify(e))
  return Promise.resolve(e.response)
}

const ApiService = {
  get: (url, header) => {
    if (debug) {
      console.log('GET ' + url)
    }
    url = baseUrl + url
    return axios.get(url, header).then(onSuccess).catch(onError)
  },
  post: (url, params, header) => {
    url = baseUrl + url
    if (debug) {
      console.log('POST ' + url + ' >> ' + JSON.stringify(params))
    }
    if (!header) {
      return axios.post(url, params).then(onSuccess).catch(onError)
    } else {
      return axios.post(url, params, header).then(onSuccess).catch(onError)
    }
  },
  patch: (url, params) => {
    url = baseUrl + url
    if (debug) {
      console.log('PUT ' + url + ' >> ' + JSON.stringify(params))
    }
    return axios.put(url, params).then(onSuccess).catch(onError)
  },
  delete: (url, header) => {
    url = baseUrl + url
    if (debug) {
      console.log('DELETE ' + url)
    }
    return axios.delete(url, header).then(onSuccess).catch(onError)
  }
}
export default ApiService



// WEBPACK FOOTER //
// ./src/store/ApiService.js